import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const BillingAmount: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <NumberField
    name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.BillingAmount}`}
    label={'Billing Amount'}
    placeholder={'$0.00'}
    mode={'currency'}
    data-test-id={'fee-detail-amount'}
    readOnly={readOnly}
  />
);
